// src/components/volunteer/VolunteerList.jsx
import React, { useState, useEffect } from 'react';
import api from '../services/api';
import './VolunteerList.css'; // Our plain CSS file

const VolunteerList = () => {
  const [volunteers, setVolunteers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchVolunteers = async () => {
      try {
        const data = await api.get('/volunteers');
        setVolunteers(data);
        setLoading(false);
      } catch (err) {
        setError(err.message);
        setLoading(false);
        alert('Failed to fetch volunteers');
      }
    };

    fetchVolunteers();
  }, []);

  const handleDelete = async (id) => {
    if (window.confirm('Are you sure you want to delete this volunteer?')) {
      try {
        await api.delete(`/volunteers/${id}`);
        setVolunteers(volunteers.filter(volunteer => volunteer.id !== id));
        alert('Volunteer deleted successfully');
      } catch (err) {
        alert('Failed to delete volunteer');
      }
    }
  };

  if (loading) return <div className="loading-message">Loading...</div>;
  if (error) return <div className="error-message">{error}</div>;

  return (
    <div className="volunteer-list-container">
      <h2 className="list-title">Volunteer Applications</h2>
      
      <div className="table-container">
        <table className="volunteer-table">
          <thead>
            <tr>
              <th>Name</th>
              <th>Email</th>
              <th>Phone</th>
              <th>Skills</th>
              <th>Availability</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {volunteers.length === 0 ? (
              <tr>
                <td colSpan="6" className="no-data">No volunteer applications found</td>
              </tr>
            ) : (
              volunteers.map((volunteer) => (
                <tr key={volunteer.id}>
                  <td>{volunteer.name}</td>
                  <td>{volunteer.email}</td>
                  <td>{volunteer.phone}</td>
                  <td>{volunteer.skills || '-'}</td>
                  <td className="capitalize">{volunteer.availability}</td>
                  <td>
                    <button
                      onClick={() => handleDelete(volunteer.id)}
                      className="delete-button"
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default VolunteerList;